export const productLinks = [
  { title: "Loyalty Management", href: "/customer-loyalty-platform" },
  { title: "WhatsApp Marketing", href: "/whatsapp-loyalty-marketing" },
  { title: "Customer Campaigns", href: "/customer-engagement-campaigns" },
  { title: "Referral", href: "/referral-rewards-software" },
];
